import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import { ADD_TEMPLATE, EDIT_TEMPLATE, GET_TEMPLATE } from "./actionTypes";
import {
  addTemplate,
  editTemplate,
  getTemplate,
} from "../../http/UAM/emailTemplate.helper";
import { allTemplate } from "./action";
import { decryptedValue } from "common/utility";
const encryptedtemplate = btoa("email");

function* addTemplates({ payload: { template, history } }) {
  try {
    const responseFromAPI = yield call(addTemplate, template);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
    } 
  } catch (error) {
    console.error("error", error);
  }
}

function* getTemplates({ payload: { data } }) {
  try {
    const responseFromAPI = yield call(getTemplate, data);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allTemplate({ data }));
    } else {
      yield put(allTemplate({ data: [] }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editTemplates({ payload: { template, history } }) {
  try {
    const responseFromAPI = yield call(editTemplate, template);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* templateSaga() {
  yield takeLatest(ADD_TEMPLATE, addTemplates);
  yield takeLatest(GET_TEMPLATE, getTemplates);
  yield takeLatest(EDIT_TEMPLATE, editTemplates);
}

export default templateSaga;
